import { httpClient as http } from '@/utils/http'
import type {
  PageResponse,
  SupplierQuotationListVO,
  SupplierQuotationPageRequest,
  SupplierQuotationSubmitRequest,
  SupplierQuotationVO
} from './types'

const BASE = '/price/supplier-quotation'

/** 分页查询报价列表 */
export const pageSupplierQuotation = (params: SupplierQuotationPageRequest) => {
  return http.post<PageResponse<SupplierQuotationListVO>>(`${BASE}/page`, params)
}

/** 获取报价详情 */
export const getSupplierQuotation = (id: string | number) => {
  return http.post<SupplierQuotationVO>(`${BASE}/get`, { id })
}

/** 按 token 获取报价（供应商 H5） */
export const getSupplierQuotationByToken = (accessToken: string) => {
  return http.post<SupplierQuotationVO>(`${BASE}/get-by-token`, { accessToken })
}

/** 保存草稿 */
export const saveSupplierQuotationDraft = (params: SupplierQuotationSubmitRequest) => {
  return http.post<boolean>(`${BASE}/save-draft`, params)
}

/** 提交报价 */
export const submitSupplierQuotation = (params: SupplierQuotationSubmitRequest) => {
  return http.post<boolean>(`${BASE}/submit`, params)
}

/** 放弃报价 */
export const abandonSupplierQuotation = (id: string | number) => {
  return http.post<boolean>(`${BASE}/abandon`, { id })
}
